import {runIfExist} from './common';

/**
 * @param {Function} callback
 */
export function runCallback(callback) {
  runIfExist(callback);
}
